import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0915aa9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onInput"]
const _hoisted_2 = {
  key: 0,
  class: "w-100 companies-list"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Name ")
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Company Number ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Address", -1))
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Phone Number ")
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Email ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Welcome Email Template", -1))
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "convert-new-lines" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["href"]
const _hoisted_17 = {
  key: 0,
  class: "copy-action"
}
const _hoisted_18 = ["href"]
const _hoisted_19 = ["onChange", "onUpdate:modelValue"]
const _hoisted_20 = ["value", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SortIcon = _resolveComponent("SortIcon")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ListView = _resolveComponent("ListView")!
  const _component_confirm_dialog = _resolveComponent("confirm-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ListView, {
      name: _ctx.name,
      showTitle: false,
      actions: _ctx.companiesActions,
      resolveState: _ctx.resolveState,
      showEdit: false,
      filter: _ctx.filter
    }, {
      edit: _withCtx(({}) => []),
      filters: _withCtx(({ loadPage }) => [
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          placeholder: "Search company name or number...",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
          onInput: ($event: any) => (loadPage(0))
        }, null, 40, _hoisted_1), [
          [_vModelText, _ctx.search]
        ])
      ]),
      list: _withCtx(({
        selectedItem,
        items,
        setSelected,
        setSort,
        sortBy,
        sortByDescending
      }) => [
        (items.length > 0)
          ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    class: "cursor-pointer",
                    onClick: _withModifiers(($event: any) => (setSort('Name')), ["prevent"])
                  }, [
                    _hoisted_4,
                    _createVNode(_component_SortIcon, {
                      sortBy: sortBy,
                      sortByDescending: sortByDescending,
                      field: "Name"
                    }, null, 8, ["sortBy", "sortByDescending"])
                  ], 8, _hoisted_3),
                  _createElementVNode("th", {
                    class: "cursor-pointer",
                    onClick: _withModifiers(($event: any) => (setSort('CompanyNumber')), ["prevent"])
                  }, [
                    _hoisted_6,
                    _createVNode(_component_SortIcon, {
                      sortBy: sortBy,
                      sortByDescending: sortByDescending,
                      field: "CompanyNumber"
                    }, null, 8, ["sortBy", "sortByDescending"])
                  ], 8, _hoisted_5),
                  _hoisted_7,
                  _createElementVNode("th", {
                    class: "cursor-pointer",
                    onClick: _withModifiers(($event: any) => (setSort('PhoneNumber')), ["prevent"])
                  }, [
                    _hoisted_9,
                    _createVNode(_component_SortIcon, {
                      sortBy: sortBy,
                      sortByDescending: sortByDescending,
                      field: "PhoneNumber"
                    }, null, 8, ["sortBy", "sortByDescending"])
                  ], 8, _hoisted_8),
                  _createElementVNode("th", {
                    class: "cursor-pointer",
                    onClick: _withModifiers(($event: any) => (setSort('Email')), ["prevent"])
                  }, [
                    _hoisted_11,
                    _createVNode(_component_SortIcon, {
                      sortBy: sortBy,
                      sortByDescending: sortByDescending,
                      field: "Email"
                    }, null, 8, ["sortBy", "sortByDescending"])
                  ], 8, _hoisted_10),
                  _hoisted_12
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cast(items), (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id,
                    class: _normalizeClass(item.id == selectedItem?.id ? 'selected-row' : ''),
                    onClick: _withModifiers(($event: any) => (setSelected(item)), ["prevent"])
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.name), 1),
                    _createElementVNode("td", null, _toDisplayString(item.companyNumber), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.formatAddress(item)), 1),
                    _createElementVNode("td", null, [
                      (item.telephoneNumber)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("a", {
                              href: 'tel:' + item.telephoneNumber
                            }, _toDisplayString(item.telephoneNumber), 9, _hoisted_16)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, [
                      (item.emailAddress)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("a", {
                              href: 'mailto:' + item.emailAddress
                            }, _toDisplayString(item.emailAddress), 9, _hoisted_18),
                            _createVNode(_component_font_awesome_icon, {
                              icon: ['far', 'clipboard'],
                              onClick: _withModifiers(($event: any) => (_ctx.setClipboard(item.emailAddress)), ["prevent"])
                            }, null, 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("select", {
                          onChange: ($event: any) => (_ctx.setTemplate(item, $event.target.value)),
                          "onUpdate:modelValue": ($event: any) => ((item.welcomeEmailTemplateId) = $event)
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getWelcomeEmailOptions(
                      item,
                      _ctx.welcomeEmailOptions
                    ), (option) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: option.id,
                              key: option.id,
                              disabled: !option.isAssignable
                            }, _toDisplayString(option.name), 9, _hoisted_20))
                          }), 128))
                        ], 40, _hoisted_19), [
                          [_vModelSelect, item.welcomeEmailTemplateId]
                        ])
                      ])
                    ])
                  ], 10, _hoisted_13))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["name", "actions", "resolveState", "filter"]),
    _createVNode(_component_confirm_dialog, { ref: "confirmDialog" }, null, 512)
  ], 64))
}